import React from 'react';
import {NavLink} from 'react-router-dom';
import '../../CSS/navbar.scss';

const Navbar = ()=> {
return (
<div className="navbar-parent">
    <nav className="mb-1 navbar navbar-expand-lg navbar-dark" style={{width: "80%",margin: "0 auto"}}>
        <NavLink className="navbar-brand" to="/">Tonmoy</NavLink>
        <button className="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent-333" aria-controls="navbarSupportedContent-333" aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent-333">
            <ul className="navbar-nav ml-auto nav-inline-icons">
                <li className="nav-item">
                    <NavLink className="nav-link" exact activeClassName="active-nav" to="/main">HOME</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" exact activeClassName="active-nav" to="/main/about">ABOUT
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" exact activeClassName="active-nav" to="/main/contact">CONTACT
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" exact activeClassName="active-nav" to="/main/portfolio">
                        PORTFOLIO</NavLink>
                </li>
            </ul>
        </div>
    </nav>
</div>

);
}

export default Navbar;